import * as React from "react";
import clsx from "clsx";
import { FieldErrors } from "react-hook-form";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";

interface OwnProps {
  name: string;
  label?: string;
  helpText?: string;
  options: Array<{
    label: string;
    value: any;
  }>;
  register: any;
  clearErrors: any;
  errors?: FieldErrors<any>;
  // we eventually want to switch to error message string completely
  // instead of sending entire errors object
  errorMessage?: string;
  isRequired?: boolean;
  onChange?: Function;
  disabled?: boolean;
  formGroup?: boolean;
}

export const SelectFormField: React.FC<OwnProps> = (props) => {
  const errors = props.errors;
  const hasError = !!errors?.[props.name];
  const errorMessageString = errors?.[props.name]?.message as string;

  return (
    <div
      className={clsx({
        "w-100": true,
        "has-error": hasError,
        "form-group": props.formGroup ?? true,
      })}
    >
      {props.label && (
        <StyledText
          color={colors.textPrimary}
          className="bodySubtextSemibold mb-2"
        >
          {props.label}
        </StyledText>
      )}
      <select
        className={clsx("form-control", { "text-muted": props.disabled })}
        required={props.isRequired}
        {...props.register(props.name as any)}
        onChange={(e: any) => {
          props.onChange && props.onChange(e);
          props.register(props.name as any).onChange(e);
          props.clearErrors(props.name);
        }}
      >
        {props.options.map((o) => (
          <option disabled={props.disabled} key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {props.errorMessage && (
        <StyledText
          color={colors.errorDark}
          className="bodySubtextRegular mt-2"
        >
          {props.errorMessage}
        </StyledText>
      )}
      {!props.errorMessage && hasError && (
        <StyledText
          color={colors.errorDark}
          className="bodySubtextRegular mt-2"
        >
          {errorMessageString}
        </StyledText>
      )}
      {props.helpText && !hasError && !props.errorMessage && (
        <StyledText
          color={colors.textSecondary}
          className="bodySubtextRegular mt-2 mb-0"
        >
          {props.helpText}
        </StyledText>
      )}
    </div>
  );
};
